import { Button } from '@cian/ui-kit';
import * as React from 'react';

interface IValuationFiltersSubmitProps {
  isLoading: boolean;
  disabled: boolean;
  onClick(): void;
  submitText: string;
}

export const ValuationFiltersSubmit = React.forwardRef<HTMLButtonElement, IValuationFiltersSubmitProps>(
  (props, ref) => {
    const { submitText, onClick, isLoading, disabled } = props;

    return (
      <div data-name="valuation_form_submit">
        <Button ref={ref} size="M" loading={isLoading} disabled={disabled} onClick={onClick} fullWidth>
          {submitText}
        </Button>
      </div>
    );
  },
);

ValuationFiltersSubmit.displayName = 'ValuationFiltersSubmit';
